// extracted by mini-css-extract-plugin
module.exports = {"applyMargin":"ProjectCriteriaFilter_applyMargin_3uDPp","dropdownItem":"ProjectCriteriaFilter_dropdownItem_2pwix","spinAround":"ProjectCriteriaFilter_spinAround_E22XR"};